/**
 * BackupSettings Component
 * Manages local file backup (export/import) and cloud sync inside SettingsModal
 */
import React from 'react';
import { Download, Upload, HardDrive, Cloud, LogIn, LogOut, FileJson, CheckCircle2 } from 'lucide-react';

export function BackupSettings({
  user,
  fileHandle,
  isFileSystemSupported,
  isLegacyFileInputSupported,
  loadData,
  loadDataLegacy,
  saveData,
  loginWithGoogle,
  logout,
}) {
  return (
    <div className="backup-settings-pane">
      {/* Local Storage & File Backup Section */}
      <div className="backup-section">
        <h3 className="backup-section-title">
          <HardDrive size={17} /> Sao Lưu Cục Bộ (Local Backup)
        </h3>
        <p className="settings-pane-desc">
          Xuất dữ liệu ma trận ra máy tính để lưu trữ an toàn hoặc khôi phục từ tệp sao lưu.
        </p>

        <div className="backup-status-card">
          <div className="backup-status-icon">
            {fileHandle ? <FileJson size={20} className="text-blue" /> : <CheckCircle2 size={20} className="text-green" />}
          </div>
          <div className="backup-status-info">
            <strong>{fileHandle ? 'Đang lưu tệp trực tiếp (Direct File Save)' : 'Tự động lưu trình duyệt (LocalStorage)'}</strong>
            <span>{fileHandle ? 'Mọi thay đổi được lưu trực tiếp vào tệp trên máy tính' : 'Dữ liệu được lưu an toàn trong trình duyệt web của bạn'}</span>
          </div>
        </div>

        <div className="backup-actions-grid">
          <button
            type="button"
            className="backup-action-btn export-btn"
            onClick={saveData}
          >
            <Download size={18} className="btn-icon" />
            <div className="action-btn-text">
              <strong>Xuất tệp JSON dự phòng</strong>
              <span>Tải về tệp .json chứa các task và ma trận</span>
            </div>
          </button>

          {(isFileSystemSupported || isLegacyFileInputSupported) && (
            <button
              type="button"
              className="backup-action-btn import-btn"
              onClick={() => (isFileSystemSupported ? loadData() : loadDataLegacy())}
            >
              <Upload size={18} className="btn-icon" />
              <div className="action-btn-text">
                <strong>Nhập từ tệp JSON</strong>
                <span>Khôi phục dữ liệu từ tệp .json đã lưu</span>
              </div>
            </button>
          )}
        </div>
      </div>

      <div className="settings-divider"></div>

      {/* Cloud Sync Section */}
      <div className="backup-section">
        <h3 className="backup-section-title">
          <Cloud size={17} /> Đồng Bộ Đám Mây (Cloud Sync)
        </h3>
        {user ? (
          <div className="cloud-user-card">
            <div className="cloud-user-details">
              {user.user_metadata?.avatar_url ? (
                <img src={user.user_metadata.avatar_url} alt="Avatar" className="user-avatar-small" />
              ) : (
                <Cloud size={18} className="cloud-icon" />
              )}
              <div className="cloud-text">
                <strong>{user.user_metadata?.full_name || 'Đã kết nối tài khoản'}</strong>
                <span>{user.email}</span>
              </div>
            </div>
            <button type="button" className="cloud-logout-btn" onClick={logout}>
              <LogOut size={15} /> Đăng xuất
            </button>
          </div>
        ) : (
          <div className="cloud-login-prompt">
            <p className="settings-pane-desc">
              Đăng nhập tài khoản Google để tự động đồng bộ công việc trên nhiều thiết bị.
            </p>
            <button type="button" className="cloud-login-btn" onClick={loginWithGoogle}>
              <LogIn size={16} /> Đăng nhập với Google
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
